import { jsxs, jsx, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { TimesSolid as n } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/times-solid.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import { DialogGridContainer } from "./styles/container.es.js";
import MuiDialogActions from "../../../node_modules/@mui/material/DialogActions/DialogActions.es.js";
import { Button } from "../button/button.es.js";
import Grid from "../../../node_modules/@mui/material/Grid/Grid.es.js";
import MuiDialog from "../../../node_modules/@mui/material/Dialog/Dialog.es.js";
import MuiDialogTitle from "../../../node_modules/@mui/material/DialogTitle/DialogTitle.es.js";
import MuiDialogContent from "../../../node_modules/@mui/material/DialogContent/DialogContent.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { IconButton } from "../icon-button/icon-button.es.js";
import { Typography } from "../typography/typography.es.js";
function Dialog({
  id,
  children,
  title,
  description,
  primaryButton,
  secondaryButton,
  icon,
  maxWidth,
  onCloseButtonClick,
  ...rest
}) {
  const titleVariant = maxWidth === "sm" || maxWidth === "xs" ? "h6" : "h5";
  const descriptionVariant = maxWidth === "sm" || maxWidth === "xs" ? "body2" : "body1";
  return /* @__PURE__ */ jsxs(MuiDialog, { ...rest, maxWidth, children: [
    /* @__PURE__ */ jsx(Box, { display: Displaying.flex, justifyContent: Alignment.flexEnd, children: onCloseButtonClick ? /* @__PURE__ */ jsx(IconButton, { size: "small", onClick: onCloseButtonClick, children: /* @__PURE__ */ jsx(n, {}) }) : /* @__PURE__ */ jsx(Fragment, {}) }),
    /* @__PURE__ */ jsxs(DialogGridContainer, { container: true, children: [
      icon && /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx("div", { className: "inner-icon", children: icon }) }),
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(MuiDialogTitle, { component: titleVariant, children: title }) }),
      description && /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(Typography, { variant: descriptionVariant, color: "textSecondary", children: description }) }),
      /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(MuiDialogContent, { children }) }),
      /* @__PURE__ */ jsx(Grid, { className: "align-end", item: true, children: /* @__PURE__ */ jsxs(MuiDialogActions, { children: [
        secondaryButton && /* @__PURE__ */ jsx(Button, { ...secondaryButton }),
        /* @__PURE__ */ jsx(Button, { ...primaryButton })
      ] }) })
    ] })
  ] });
}
export {
  Dialog
};
//# sourceMappingURL=dialog.es.js.map
